const inputRange = document.querySelector(
  ".offers-filter input.slider"
);
if (inputRange) {
  const min = Number(inputRange.min);
  const max = Number(inputRange.max);

  const fullfiledLine = document.querySelector(".offers-filter .fullfiledLine");
  const inputText = document.querySelector(".offers-filter .input");

  const setSliderWidth = (value) => {
    let width = ((+value - min) / (max - min)) * 100;

    fullfiledLine.style.width = `${width}%`;
  };

  inputRange.addEventListener("input", (e) => {
    let value = Number(e.target.value);

    if (value > max) {
      value = max;
    }
    if (value < min) {
      value = min;
    }

    setSliderWidth(value);
    inputText.value = value;
    // inputRange.value = value;
  });
  inputText.addEventListener("input", (e) => {
    let value = Number(e.target.value);

    if (value > max) {
      value = max;
    }
    if (value < min) {
      value = min;
    }

    setSliderWidth(value);
    // inputText.value = value;
    inputRange.value = value;
  });
  inputText.addEventListener("change", (e) => {
    let value = Number(e.target.value);

    if (value > max) {
      e.target.value = max;
    }
    if (value < min) {
      e.target.value = min;
    }
  });

  document
    .querySelector("form.offers-filter")
    .addEventListener("submit", (e) => {
      e.preventDefault();

      document.querySelectorAll(".offers-list__item")?.forEach((item) => {
        if (Number(item.getAttribute("data-sum")) <= Number(inputRange.value)) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
    });
}